import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Scorecard, ScorecardService } from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardDescriptionComponent } from '../../scorecard-description/scorecard-description.component';
import { Router } from '@angular/router';

@Component({
  selector: 'fgbcl-scorecard-streak',
  templateUrl: './scorecard-streak.component.html',
  styleUrls: ['./scorecard-streak.component.scss', '../scorecard-display-shared.scss'],
})
export class ScorecardStreakComponent implements OnInit {
  @Input() scorecard: Scorecard;
  @Input() isSponsorInBody: boolean = false;
  @Input() confettiColors: string[];
  @Input() disabled: boolean = false;
  isOpenModal: boolean = true;

  constructor(
    private offcanvasService: NgbOffcanvas,
    private router: Router,
    private scorecardService: ScorecardService
  ) {}

  ngOnInit(): void {
    this.onWindowResize(window.innerWidth);
  }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 576) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  openScorecardDescription() {
    if (!this.disabled) {
      this.isOpenModal ? this.openModal() : this.redirectComponent();
    }
  }

  openModal() {
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.confettiColors = this.confettiColors;
    offcanvasRef.componentInstance.scorecardId = this.scorecard.ScorecardId;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }

  redirectComponent() {
    const initVal = { confettiColors: this.confettiColors };
    let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};
    this.scorecardService.initDataScorecardDescription$.next(initVal);
    this.router.navigate(['/scorecard-description', this.scorecard.ScorecardId, params]);
  }
}
